// RepeatRequired nodes are used for `a+` regular expression syntax. It is not
// rendered directly; it just indicates that the [Repeat](./repeat.html) node
// loops one or more times.

export default {
  minimum: 1,
  maximum: -1
};
